<template lang="pug">
    .row.faqs-wrapper
        .col-12.col-sm-12.menu-mobile
            h1 Centro de aprendizaje
            h2(style="display:none;") Ayuda e información sobre los registros, servicios y soporte.

            .row
                .col-12.col-sm-12
                    .category-box
                        h3 Categorías
                        ul
                            li(v-for="category in categories", v-bind:class="(selectedCategory && (category.id == selectedCategory.id)) ? 'active':''", @click="selectCategory(category)") {{category.name}}
        .col-12.col-sm-12.col-lg-9
            h1.desktop-only Centro de aprendizaje
            h2.desktop-only(style="display:none;") Ayuda e información sobre los registros, servicios y soporte.
            hr.desktop-only
            .row(v-if="selectedCategory")
                .col-10.offset-1.col-sm-10.offset-sm-1.col-lg-12.offset-lg-0
                    h4 {{selectedCategory.name}}
                .col-10.offset-1.col-sm-10.offset-sm-1.col-lg-12.offset-lg-0.entry(v-for="(entry, index) in entries", :class="{even: index % 2, odd: !(index % 2)}")
                    FaqEntry(v-bind:entry="entry")
        .col-3.col-sm-3.col-lg-3.desktop-menu(v-if="categories.length")
            .category-box
                h3 Categorías
                ul
                    li(v-for="category in categories", v-bind:class="(selectedCategory && (category.id == selectedCategory.id)) ? 'active':''", @click="selectCategory(category)") {{category.name}}
</template>

<script>
import _ from 'underscore'
import Api from './services/Api'
import FaqEntry from '@/components/FaqEntry'

export default {
  name: 'Faqs',
  components: { FaqEntry },
  data() {
    return {
      categories: [],
      entries: [],
      selectedCategory: null,
    }
  },
  created() {
    const _this = this

    Api.getCategories('learning_center')
      .then(response => {
        _this.categories = response.data.items
        if (_this.categories.length) _this.selectCategory(_this.categories[0])
      })
      .catch()
  },
  methods: {
    selectCategory(category) {
      const _this = this
      const token = this.$store.state.token

      Api.getEntriesByParent(category.id, token).then(response => {
        _this.entries = _.sortBy(response.data.items, item => {
          return item.title.rendered
        })
        _this.selectedCategory = category
        console.log(_this.entries[0])
      })
    },
  },
}
</script>

<style scoped lang="scss">
@import './../variables';

.desktop-menu {
  @include breakpoint($breakpoint-tablet) {
    display: none;
  }
}

.menu-mobile {
  display: none;

  @include breakpoint($breakpoint-tablet) {
    display: block;
  }
}

h1 {
  font-size: 2.3em;
  color: #000;
  margin-bottom: $gutter * 1.5;
  font-weight: 700;
}

h2 {
  color: $color-primary;
  font-weight: 400;
  font-size: 1.4em;
  margin-bottom: $gutter * 1.5;
}

h4 {
  font-weight: 700;
  font-family: $font-secondary;
  font-size: 1.9em;
  margin: $gutter 0;
}

hr {
  border-top: 7px solid #e3e3e3;
  margin-bottom: $gutter * 1.5;
  display: block;
  width: 100px;
  clear: both;
  margin-left: 0;
  @include breakpoint($breakpoint-tablet) {
    display: none;
  }
}

.faqs-wrapper {
  margin: $gutter * 3 auto;
  max-width: 1140px;
}

.category-box {
  background-color: #e3e3e3;

  @include breakpoint($breakpoint-tablet) {
    margin: $gutter * 2 0;
  }

  h3 {
    color: $color-primary;
    padding: $gutter 0;
    text-align: center;
    font-size: 1.2em;
    font-weight: 700;
  }

  ul {
    li {
      @include clearfix();
      padding: $gutter;
      cursor: pointer;
      font-size: 0.9em;
      text-align: center;
      color: #000;
      border-top: 1px solid #efefef;
      @include breakpoint($breakpoint-tablet) {
        font-size: 1.1em;
      }
    }
    li:last {
      border-bottom: 1px solid #efefef;
    }

    li.active {
      background-color: #fff;
    }
  }
}

.odd {
  .faq-entry-wrapper {
    background-color: #f6f6f6;
  }
}

.odd,
.even {
  .faq-entry-wrapper {
    border-top: 2px solid #dfdede;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LearningCenter.vue